import { render, staticRenderFns } from "./ForDelivery.vue?vue&type=template&id=4232342e&"
import script from "./ForDelivery.vue?vue&type=script&lang=js&"
export * from "./ForDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports